"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var DropDown_1 = __importDefault(require("../../../../common/DropDown/DropDown"));
var react_i18next_1 = require("react-i18next");
var general_1 = require("../../../../lib/general");
function CategorySelector(props) {
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n, getCurrentLang = i18n.language.toLowerCase(), _b = (0, react_1.useState)([]), categoryArr = _b[0], setCategoryArr = _b[1];
    (0, react_1.useEffect)(function () {
        if (props.list && props.list.length > 0) {
            var output_1 = [];
            props.list.map(function (item) {
                var id = item.id, value = item.id, label = (0, general_1.isJsonWithAvailableLang)(item.name ? item.name : item.label ? item.label : item.question, getCurrentLang, t), name = item.name
                    ? item.name
                    : item.label
                        ? item.label
                        : item.question;
                output_1.push({
                    id: id,
                    value: value,
                    label: label,
                    name: name,
                });
            });
            setCategoryArr(output_1);
        }
    }, [props.list, getCurrentLang]);
    return (react_1.default.createElement(DropDown_1.default, { defaultValue: props.value, error: props.error, label: props.label, name: 'Category', onChange: function (e) {
            props.updateCategory(e);
        }, options: categoryArr, value: props.value }));
}
CategorySelector.propTypes = {
    error: prop_types_1.default.any,
    placeholder: prop_types_1.default.string,
    style: prop_types_1.default.object,
    className: prop_types_1.default.string,
    label: prop_types_1.default.any,
    list: prop_types_1.default.any,
    value: prop_types_1.default.any,
    updateCategory: prop_types_1.default.any,
};
exports.default = CategorySelector;
